import React, { useState, useEffect } from 'react';
import { useAlert } from '../context/AlertContext';
import { createEvent, updateEvent } from '../services/eventService';

const EventForm = ({ event, onClose, onSuccess }) => {
  const { showAlert } = useAlert();
  const [isProcessing, setIsProcessing] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    date: '',
    time: '',
    location: '',
    description: '',
    fee: 300,
    capacity: 28,
    image_url: 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=800',
  });

  const isEditMode = !!event;

  useEffect(() => {
    if (event) {
      setFormData({
        title: event.title || '',
        date: event.date || '',
        time: event.time || '',
        location: event.location || '',
        description: event.description || '',
        fee: event.fee || 300,
        capacity: event.capacity || 28,
        image_url: event.image_url || 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=800',
      });
    }
  }, [event]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsProcessing(true);

    try {
      const eventData = {
        ...formData,
        fee: parseFloat(formData.fee),
        capacity: parseInt(formData.capacity),
      };

      if (isEditMode) {
        await updateEvent(event.id, eventData);
        showAlert('Event updated successfully!', 'success');
      } else {
        await createEvent(eventData);
        showAlert('Event created successfully!', 'success');
      }

      onSuccess();
      onClose();
    } catch (error) {
      showAlert(error.message || 'Error saving event. Please try again.', 'error');
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="form-label">Event Title *</label>
        <input
          type="text"
          name="title"
          className="form-input"
          value={formData.title}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Date *</label>
        <input
          type="date"
          name="date"
          className="form-input"
          value={formData.date}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Time *</label>
        <input
          type="text"
          name="time"
          className="form-input"
          value={formData.time}
          onChange={handleChange}
          placeholder="e.g., 1:00 PM"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Location *</label>
        <input
          type="text"
          name="location"
          className="form-input"
          value={formData.location}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Description *</label>
        <textarea
          name="description"
          className="form-textarea"
          value={formData.description}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Fee (USD) *</label>
        <input
          type="number"
          name="fee"
          className="form-input"
          value={formData.fee}
          onChange={handleChange}
          min="0"
          step="0.01"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Capacity *</label>
        <input
          type="number"
          name="capacity"
          className="form-input"
          value={formData.capacity}
          onChange={handleChange}
          min="1"
          required
        />
      </div>

      <div className="form-group">
        <label className="form-label">Image URL *</label>
        <input
          type="url"
          name="image_url"
          className="form-input"
          value={formData.image_url}
          onChange={handleChange}
          placeholder="https://example.com/image.jpg"
          required
        />
        {formData.image_url && (
          <img
            src={formData.image_url}
            alt="Preview"
            className="image-preview"
            onError={(e) => {
              e.target.style.display = 'none';
            }}
          />
        )}
      </div>

      <button type="submit" className="submit-button" disabled={isProcessing}>
        {isProcessing ? 'Saving...' : isEditMode ? 'Update Event' : 'Create Event'}
      </button>
    </form>
  );
};

export default EventForm;
